import React, { useState, useEffect } from 'react';
import { Nav, Navbar, NavDropdown, Row, Col } from 'react-bootstrap';
import Amplify, { Auth } from 'aws-amplify';
import { Avatar } from 'antd';

export default function NavBar() {
    
    const [username, setUsername] = useState();
    const [email, setEmail] = useState();
    const [isLoaded, setIsLoaded] = useState(false);
    
    
    function getUserInfo() {
		Auth.currentAuthenticatedUser({
			bypassCache: false
		}).then(
			user => {
				console.log(user);
                setUsername(user.attributes.given_name);
				setEmail(user.attributes.email);
                setIsLoaded(true);
			}
		)
			.catch(err => console.log(err));
	}

	useEffect(() => {
		getUserInfo();
	}, [])
    return (
        <Row>
            <Col md={10}>
                <Navbar expand="lg" variant="dark" style={{ background: "inherited" }}>
                    <Navbar.Brand href="/">AlphaFold2 TIB Server</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">

                        <Nav className="mr-auto">
                            <Nav.Link href="/home">Home</Nav.Link>
                            <Nav.Link href="/results">Results</Nav.Link>
                            {/* <Nav.Link href="/queue">Queue</Nav.Link> */}
                        </Nav>


                    </Navbar.Collapse>
                </Navbar>
            </Col>
            <Col md={2}>
                <Navbar expand="lg" variant="dark" style={{ background: "inherited" }}>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="mr-auto">
                            {/* <Nav.Link href="/signout">Sign Out</Nav.Link> */}
                            <NavDropdown title={<Avatar>{username}</Avatar>} id="basic-nav-dropdown">
                                <NavDropdown.Item>Name: {username}</NavDropdown.Item>
                                <NavDropdown.Item>Email: {email}</NavDropdown.Item>
                               
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/signout">
                                    Sign Out
                                </NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </Col>
        </Row>
    )
}
